import styled from 'styled-components';
import { COLORS } from '../../../../../constants/radar';

export const TabToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  margin-bottom: 28px;
`;

export const GroupSection = styled.div`
  margin-bottom: 28px;
`;

export const GroupHeader = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  padding: 8px 12px;
  background-color: #EFF6FF;
  border-left: 3px solid ${COLORS.PRIMARY};
  border-radius: 0 4px 4px 0;
  margin-bottom: 12px;
`;

/* ── Target sub-group ─────────────────────────────────────────────────────── */

export const TargetSubGroup = styled.div`
  margin-bottom: 12px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
`;

export const TargetSubGroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: #f1f5f9;
  border-bottom: 1px solid #e0e0e0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
`;

/* ── Timeline ─────────────────────────────────────────────────────────────── */

export const TimelineWrapper = styled.div`
  padding: 8px 16px;
`;

export const TimelineItem = styled.div`
  display: flex;
  gap: 12px;
  position: relative;
  padding-bottom: ${props => props.$last ? '8px' : '20px'};

  /* Vertical connecting line */
  &::before {
    content: '';
    position: absolute;
    left: 7px;
    top: 16px;
    bottom: ${props => props.$last ? '100%' : '0'};
    width: 2px;
    background-color: #E2E8F0;
    display: ${props => props.$last ? 'none' : 'block'};
  }
`;

export const TimelineDot = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #D6DAE1;
  flex-shrink: 0;
  margin-top: 7px;
  border: 2px solid white;
  box-shadow: 0 0 0 2px #D6DAE1;
  position: relative;
  z-index: 1;
`;

export const TimelineItemContent = styled.div`
  flex: 1;
  min-width: 0;
  padding-bottom: 4px;
`;

export const TimelineItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
`;

/* ── Shared atoms ─────────────────────────────────────────────────────────── */

export const ActivityTypeChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  background-color: ${props => props.$color || COLORS.PRIMARY}22;
  border: 1px solid ${props => props.$color || COLORS.PRIMARY}55;
  font-size: 12px;
  font-weight: 600;
  color: ${props => props.$color || COLORS.PRIMARY};
  white-space: nowrap;
`;

export const TypeColorDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.$color || COLORS.PRIMARY};
  flex-shrink: 0;
`;

export const ActivityDetail = styled.div`
  font-size: 13px;
  color: #64748B;
  margin-top: 4px;
`;

export const ActivityActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const ActivityDate = styled.div`
  font-size: 11px;
  color: #94A3B8;
  white-space: nowrap;
`;

/* ── Drawer ───────────────────────────────────────────────────────────────── */

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #E2E8F0;
`;

export const DrawerTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1E293B;
`;

export const DrawerBody = styled.div`
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DrawerFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #E2E8F0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const SourceProjectBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background-color: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 14px;
  color: #1E293B;
`;

export const SourceProjectLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  display: block;
`;

export const CustomToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 4px;
`;
